import { useCallback, useReducer } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import { usePublicOfferCalls } from './public-offer-calls.hook'
import { publicOfferReducer } from '../reducers'
import { PUBLIC_OFFER_INITIAL_STATE, PUBLIC_OFFER_ACTIONS_TYPES } from '../reducers'

export const usePublicOfferReducer = () => {
  const [state, dispatch] = useReducer(publicOfferReducer, PUBLIC_OFFER_INITIAL_STATE)
  const navigate = useNavigate()
  const location = useLocation()
  const {
    getPublicOffersCall,
    getPublicOfferCall,
    putPublicOfferCall,
    postPublicOfferCall,
    putPublicOfferStatusCall,
    // getPublicOffersGeneralTermsCall,
  } = usePublicOfferCalls()

  const getTableData = useCallback(
    (search) => {
      const config = { params: search }
      dispatch({
        type: PUBLIC_OFFER_ACTIONS_TYPES.SET_LOADING,
      })
      getPublicOffersCall(config)
        .then(({ data }) => {
          dispatch({
            type: PUBLIC_OFFER_ACTIONS_TYPES.SET_TABLE_DATA,
            payload: {
              data: Array.isArray(data['ofertas_publicas']) ? data['ofertas_publicas'] : [],
              search: search,
              pagination: {
                total_paginas: data['total_paginas'] || 1,
                total_ofertas_publicas: data['total_ofertas_publicas'] || 0,
              },
            },
          })
        })
        .catch((error) => {
          console.error('Error loading public offers data:', error)
          dispatch({
            type: PUBLIC_OFFER_ACTIONS_TYPES.SET_FAILURE,
          })
        })
    },
    [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  )

  // const getPublicOffersGeneralTerms = useCallback(
  //   (search) => {
  //     dispatch({
  //       type: PUBLIC_OFFER_ACTIONS_TYPES.SET_LOADING,
  //     })
  //     getPublicOffersGeneralTermsCall()
  //       .then(({ data }) => {
  //         dispatch({
  //           type: PUBLIC_OFFER_ACTIONS_TYPES.SET_TABLE_DATA,
  //           payload: {
  //             data: data['ofertas_publicas'],
  //             search: search,
  //             pagination: {
  //               total_paginas: data['total_paginas'],
  //               total_ofertas_publicas: data['total_ofertas_publicas'],
  //             },
  //           },
  //         })
  //       })
  //       .catch(() => {
  //         dispatch({
  //           type: PUBLIC_OFFER_ACTIONS_TYPES.SET_FAILURE,
  //         })
  //       })
  //   },
  //   [dispatch]// eslint-disable-line react-hooks/exhaustive-deps
  // )

  const getPublicOffer = useCallback(
    (id) => {
      return new Promise((resolve, reject) => {
        dispatch({
          type: PUBLIC_OFFER_ACTIONS_TYPES.SET_DETAIL_LOADING,
        })
        getPublicOfferCall(id)
          .then(({ data }) => {
            dispatch({
              type: PUBLIC_OFFER_ACTIONS_TYPES.SET_PUBLIC_OFFER,
              payload: data,
            })
            return resolve(data)
          })
          .catch((error) => {
            dispatch({
              type: PUBLIC_OFFER_ACTIONS_TYPES.SET_DETAIL_FAILURE,
            })
            return reject(error)
          })
      })
    },
    [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const editPublicOffer = useCallback(
    (payload) => {
      const { id, ...restPayload } = payload
      return new Promise((resolve, reject) => {
        putPublicOfferCall(id, restPayload)
          .then(({ data }) => {
            dispatch({
              type: PUBLIC_OFFER_ACTIONS_TYPES.SET_PUBLIC_OFFER,
              payload: data,
            })
            return data
          })
          .then((data) => resolve(data))
          .catch(() => {
            dispatch({
              type: PUBLIC_OFFER_ACTIONS_TYPES.SET_DETAIL_FAILURE,
            })
            return reject('Error')
          })
      })
    },
    [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const changePublicOfferStatus = useCallback(
    (id, payload) => {
      return new Promise((resolve, reject) => {
        putPublicOfferStatusCall(id, payload)
          .then(({ data }) => {
            dispatch({
              type: PUBLIC_OFFER_ACTIONS_TYPES.SET_PUBLIC_OFFER_STATUS,
              payload: { id, state: data['activa'] },
            })
          })
          .then(() => resolve())
          .catch(() => {
            dispatch({
              type: PUBLIC_OFFER_ACTIONS_TYPES.SET_FAILURE,
            })
            return reject('Error')
          })
      })
    },
    [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const createPublicOffer = useCallback(
    (payload) => {
      return new Promise((resolve, reject) => {
        postPublicOfferCall({ ...payload })
          .then(({ data }) => resolve(data))
          .catch(() => {
            dispatch({
              type: PUBLIC_OFFER_ACTIONS_TYPES.SET_DETAIL_FAILURE,
            })
            return reject('Error')
          })
      })
    },
    [dispatch] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const setSelectedTableRows = useCallback(
    (rows) => {
      dispatch({
        type: PUBLIC_OFFER_ACTIONS_TYPES.SET_TABLE_SELECTION,
        payload: rows,
      })
    },
    [dispatch, state] // eslint-disable-line react-hooks/exhaustive-deps
  )

  const onClickTableRow = (id) => {
    if (!id) {
      console.warn('No public offer ID provided for navigation')
      return
    }
    return navigate(`/public-offer/${id}`, {
      state: { prevSearch: location.search },
    })
  }

  return {
    setSelectedTableRows,
    onClickTableRow,
    getTableData,
    getPublicOffer,
    editPublicOffer,
    createPublicOffer,
    changePublicOfferStatus,
    ...state,
  }
}
